import {API_V2} from "./axiosInstance"


export const getExceptionList = async function () {
    const lijst = await API_V2.get(`/exceptions?isDeleted=0`, {});
    return lijst.data;
}

export const createEntry = async (exception) => {
    const response = await API_V2.post(`/exceptions`,  exception);
    return response.data;
  }

export const updateEntry = async(exception, staticId) => {
    const response = await API_V2.put(`/exceptions/${staticId}`, exception);
    return response.data;
}

/**
 * Accepts a requested change
 * @param {*} staticId the id of the entry in the static model
 * @returns the accepted entry
 */
export const acceptChange = async(staticId) => {
    const accept = await API_V2.post(`/exceptions/${staticId}/accept`);
    return accept.data;
}

/**
 * Rejects a requested change
 * @param {*} staticId the id of the entry in the static model
 * @returns the rejected entry
 */
export const rejectChange = async(staticId) => {
    const reject =  await API_V2.post(`/exceptions/${staticId}/reject`);
    return reject.data;
}
